// extracted by mini-css-extract-plugin
export default {"component":"SubMainPart_component__uXAo4","header":"SubMainPart_header__2Py2p","body":"SubMainPart_body__25jDL"};